import axios from '@/libs/api.request.js';

const wechat = {

    //模拟生成授权登录链接
    // getOauthUrl_test(redirectUrl) {
    //     return new Promise((resolve, reject) => {
    //         return resolve('https://blog.tanfayang.cn/aa.php?redirect_url=' + encodeURIComponent(redirectUrl));

    //     }, err => {});
    // },

    //模拟通过code换取用户信息

    getUserInfoByOauthCode(oauthCode) {

        return new Promise((resolve, reject) => {
            if (!oauthCode) {
                return reject('invalid code');
            }
            let info = {
                'token': Math.ceil(Math.random() * 10000),
                'expire_in': 7200,
            };

            return resolve(info);
        })
    },


    //生成oauth链接
    getOauthUrl({
        mp,
        version,
        redirectUrl,
        scope
    }) {
        let data = {
            mp: mp,
            version: version,
            redirectUrl: redirectUrl,
            scope: scope
        };
        return axios.get({
            url: '/wap/User/auhorizeurl?' + axios.parseParams(data),
        });
    },

    //登录
    login({
        code,
        mp,
        scope,
        state
    }) {
        let data = {
            code: code,
            mp: mp,
            scope: scope,
            state: state
        };

        return axios.get({
            url: '/wap/User/login?' + axios.parseParams(data)
        });
    },

    //模拟登陆
    loginTest(data) {
        return axios.post({
            url: '/wap/User/debuglogin?' + axios.parseParams(data)
                // data: data
        });
    },
    // loginTest({
    //     code,
    //     mp,
    //     scope,
    //     state
    // }) {
    //     let data = {
    //         code: code,
    //         mp: mp,
    //         scope: scope,
    //         state: state
    //     };

    //     return new Promise((resolve, reject) => {
    //         let rand = Math.ceil((Math.random() * 1000));
    //         let result = {
    //             "token": {
    //                 "status": true,
    //                 "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoid2FwdXNlciIsInVpZCI6IjlkZTFkZGM2LWUwMmEtNDBhZS1kYWZkLTA4ZDY0MDZhZDFlNSIsInd4T3BlbmlkIjoib0dVZjdqc1NENUxkZjJCZ3JvVmwyeDFxZjFmUSIsInRuaWQiOiJmYzc3NTc4Mi0xMjUyLTQ4MDMtNzMzNC0wOGQ2MjRmNzc1YzciLCJleHAiOjE1NTc4Mjk0ODYsIm5iZiI6MTU1NzgxMTQ4NiwiaXNzIjoiYWNoaW5heXVuIiwiYXVkIjoiYWNoaW5hIn0.5_Baql4TaOdmDyzTus_56V0v1Nhh6ssNtke33Lb-8ik",
    //                 "expires_in": 18000,
    //                 "token_type": "Bearer"
    //             },
    //             "weixinuser": {
    //                 "subscribe": 1,
    //                 "nickname": "小糊涂shen",
    //                 "headimgurl": "http://thirdwx.qlogo.cn/mmopen/NBCTCakOpvDuZBS9OO9riaIDFXULdN7oKI6YAA1cMibaPpZSeQXMZ1V3icUxCxr6oGDo8QjHOJfLO6QoUiaPcNIbtLYKrs1rFFNh/132",
    //                 "country": "摩洛哥",
    //                 "province": "",
    //                 "city": ""
    //             },
    //             //"isMember":false
    //             "isMember": true
    //         };
    //         resolve(result);
    //     });
    // },

    //绑定手机号
    signUp({
        mobile,
        code,
        openid,
        nickName,
        headerUrl,
        unionId,
        sex,
        referee,
        deptId
    }) {

        let data = {
            mobile: mobile,
            code: code,
            openid: openid,
            nickName: nickName,
            headerUrl: headerUrl,
            unionId: unionId,
            sex: sex,
            referee: referee,
            deptId: deptId,
        };

        return axios.post({
            url: '/wap/User/signup',
            data: data
        });
    },

    //绑定手机号 模拟
    signUpTest({
        mobile,
        code,
        openid,
        nickName,
        headerUrl,
        unionId,
        sex
    }) {

        let data = {
            mobile: mobile,
            code: code,
            openid: openid,
            nickName: nickName,
            headerUrl: headerUrl,
            unionId: unionId,
            sex: sex
        };

        return new Promise((resolve, reject) => {
            let rand = Math.ceil((Math.random() * 1000));

            let result = {
                token: {
                    access_token: rand + 'sdjfklsjkfljskld234234234adsf',
                    token_type: 'Bearer',
                    expires_in: 1800
                },
                register: 1
            };
            resolve(result);

        });
    },

    // 获取JSSDK签名
    getJsSdk: (locationUrl) => {
        return axios.get({
            url: '/wap/JsSdk/signature?Url=' + locationUrl
        })
    }

};

export default wechat;



// WEBPACK FOOTER //
// ./src/api/api-wechat.js